import React from "react";
import "./styles.css";
import ContentfulRichText from "../../utilities/contentful-rich-text";
import { StaticImage } from "gatsby-plugin-image";

const Faqs = ({ title, faqs }) => {
  return (
    <div className="faqs border-2 rounded-3xl">
      <h2 className="faqs-header !m-8 !mb-4 font-bold">{title || 'FAQs'}</h2>
      <div className="grid grid-cols-1 divide-y-2">
        {faqs.map(({ question, answer }, index) => (
          <div key={`question_${index}`} className="flex gap-4 py-8 px-8">
            <div className="h-full w-fit">
              <StaticImage
                src="../../images/faq_icon.png"
                alt="faq_icon"
                width={240}
                height={240}
                className="md:w-[50px] !mt-0"
              />
            </div>
            <div className="text-4xl inline">
              <h3 className="font-bold capitalize !mt-0 !mb-4">{question}</h3>
              <ContentfulRichText className="text-3xl md:leading-[35px]" raw={answer} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faqs;
